import React, { useEffect, useState } from "react"
import Breadcrumbs from "../../../components/Common/Breadcrumb"
import { Col, Row, Card, UncontrolledPopover, PopoverBody } from "reactstrap"
import UpdateTable from "../../../components/Common/UpdatedTable"
import action from "../../../assets/icons/action.svg"
import { toastError, toastSuccess } from "../../../helpers/msg_helper"
import { Link, useNavigate, useParams } from "react-router-dom"
import {
  fetchHrmsGradeControl,
  updateGradeControlStatus,
} from "../../../services/Hrms/hrms"
import capitalizeFirstLetter from "../../../utils/capitalizeFirstLetter"
import LedgerFilter from "./filter"
import { deleteledger, fetchFinanceLedgerSearch } from "../../../services/finance/finance"
import { createSelector } from "reselect"
import { useSelector } from "react-redux"
import NumberFormat from "../../../utils/numberFormat"
import StoreFilter from "./filter"
import { searchStoreProductList } from "../../../services/centralStore/centralStore"

const StoreProductView = () => {
  const companyname = localStorage.getItem('companyname')
  document.title = `Store Product${companyname ? ` | ${companyname}` : 'MEP -Hub'}`;

  const selectLoginState = state => state.Login
  const LoginProperties = createSelector(selectLoginState, login => ({
    loggedUser: login.loggedUser,
  }))

  const { loggedUser } = useSelector(LoginProperties)
  const desimalrange = localStorage.getItem("desimalrange")

  const {id} = useParams()

  const navigate = useNavigate()
  const [refresh, setRefresh] = useState(0)
  const [classData, setClassData] = useState()
  const [status, setStatus] = useState("")
  const [search, setSearch] = useState("")
  const [page, setPage] = useState("")


  const columns = [
    {
      label: "Product Name",
      renderCell: item => {
        return (
          <div
          >
            {item?.product?.product_code ? `${item?.product?.product_code} ${item?.product?.description ? `- ${item?.product?.description}` : ""}` : "-"}
          </div>
        )
      },
    },
    {
      label: "Activity",
      renderCell: item => item?.activity == "remove" ? "Out" : "In"
    },
    {
      label: <div className="text-end pe-5">Quantity</div>,
      renderCell: item => <div className="text-end pe-5">{ NumberFormat(Number(item?.quantity), desimalrange, desimalrange)}</div>,
    },
    {
      label: <div className="text-end pe-5">Rate</div>,
      renderCell: item => <div className="text-end pe-5">{ NumberFormat(Number(item?.rate), desimalrange, desimalrange)}</div>,
    },
    // {
    //   label: <div className="text-end pe-5">Opening Balance</div>,
    //   renderCell: item => <div className="text-end pe-5">{ NumberFormat(Number(item?.opening_balance), desimalrange, desimalrange)}</div>,
    // },
  ]

  const handlePaginate = page => {
    setPage(page)
  }

  useEffect(() => {
    const fetchClass = async () => {
      const response = await searchStoreProductList({
        params: `${status == "0" || status == "1" ? `&status=${status}` : ""}${
          search ? `&searchText=${search}` : "&searchText"
        }${
          page ? `&page=${page}` : ""
        }${`&account_group_id=12`}${`&sizePerPage=16`}${id ? `&ledger_id=${id}` : ""}`,
      })
      setClassData(response)
    }
    if(id) {
    fetchClass()
}
  }, [refresh, status, search, page, id])

  const handleSearchChange = data => {
    setSearch(data)
    setPage(1)
  }
  return (
    <React.Fragment>
      <div className="page-content">
        <div className="container-fluid">
          <div className="d-flex justify-content-between">
            <Breadcrumbs
              title="Central Store"
              breadcrumbObject={[
                { title: "Central Store", link: "/central-store" },
                { title: "Store", link: "/central-store/store-list" },
                { title: "Products", link: "" },
              ]}
            />
          </div>
          <Card className="me-2 px-2 pb-2">
            <Row className="mt-2 ever-rise-table">
              <Col xs={12}>
                {classData && (
                  <UpdateTable
                    className="mt-5"
                    nodes={classData?.data?.data}
                    paginate={classData?.data}
                    columns={columns}
                    CurrentPage={page}
                    handlePagination={handlePaginate}
                    tableWidth="25% 25% 25% 25%"
                    mobileWidth="25% 25% 25% 25%"
                  />
                )}
              </Col>
            </Row>
          </Card>
        </div>
      </div>
    </React.Fragment>
  )
}

export default StoreProductView
